export function Separator() {
  return (
    <div className="w-[20%] flex flex-col md:flex-row gap-1 md:gap-2 items-center">
      <div className="border-[1px] border-primary-blue-B400 h-4 border-dashed md:w-32 md:h-0" />
      <span className="text-primary-blue-B400 text-sm">oder</span>
      <div className="border-[1px] border-primary-blue-B400 h-4 border-dashed md:w-32 md:h-0" />
    </div>
  );
}
